import {peakAlert, peakConfirm} from "../../../PeakDialog.js";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import jQuery from "jquery";

let $=jQuery.noConflict();

export class ZIDXAccountContactSavedListings implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountContactSavedListingsContainer";
    }
    render() {
        // console.log("contact saved listings");
        this.bindEvents();
    }
    bindEvents(){
        let self = this;
        $(".zidxContactListingRemoveButton", this.zidx.peakidxShadowRoot).off("click").on("click", async function(this, e){
            e.preventDefault();
            if(await peakConfirm("Are you sure you want to remove this listing?")) {
                if (this instanceof HTMLAnchorElement) {
                    let button = this;

                    let obj = {
                        id: "ajaxRemoveContactListing",
                        method: "post",
                        postObj: {},
                        ignoreOldRequests: false,
                        callback: function (r: string) {
                            let rs = JSON.parse(r);
                            if (rs.success) {
                                $(button).closest(".zidxContactListingItem").remove();
                            } else {
                                peakAlert("Unable to remove listing, please try again later");
                            }
                        },
                        errorCallback: function (e: XMLHttpRequest) {
                            console.log(e.status);
                        },
                        url: this.href
                    };
                    self.zidx.ajaxRequest(obj);
                }
            }
        })
    }
}